<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <div class="indicator-overlay" v-if="isShow">
    <vue-simple-spinner size="big" line-fg-color="#3c6bbb" :style="{padding: '5rem'}" class="spinner"/>
    <!--<img src="../../assets/images/indicator.gif" class="spinner" />-->
  </div>
</template>

<script>
  import VueSimpleSpinner from 'vue-simple-spinner'
  import { mapState } from 'vuex'

  export default {
    name: 'FullIndicator',
    components: {
      VueSimpleSpinner
    },
    computed: {
      ...mapState({
        isShow: state => state.NETWORK.SHOW_INDICATOR
      })
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";

  .indicator-overlay {
    z-index: 9999;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    width: 100vw;
    background: rgba(@brown-grey, 0.5);
    .spinner {
      position: absolute;
      top: 50%;
      /* bottom: 1rem; */
      left: 50%;
      transform: translate(-50%, -50%);
      width: 10rem;
      height: 10rem;
    }
  }
</style>
